import { useMutation } from '@tanstack/react-query';

import { UpdatePasswordParameters } from '../../../../../../typings/api/skymap/rest/v0/password-reset-token';
import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';
import { RequestParamsToApiPaths } from '../../../../utils/typescript-utils';
import { useErrorHandling } from '../../../hooks/use-error-handling';
import { useParams } from '../../../hooks/use-params';
import { FormValues } from '../components/form';

const useUpdatePasswordQuery = () => {
  const { token } = useParams();
  const { handleError, hasError, clearErrors, getErrorForPath, buildErrorList, excludeErrorPaths } =
    useErrorHandling<RequestParamsToApiPaths<UpdatePasswordParameters>>();

  const mutation = useMutation({
    mutationFn: (form: FormValues) =>
      SkyMapAxiosServiceFactory.instance.createPasswordResetTokenServiceV0().updatePassword({
        body: {
          password: form.password,
        },
        path: {
          id: token,
        },
      }),
    retry: false,
    networkMode: 'always',
    onError: (error) => handleError(error),
    onMutate: () => clearErrors(),
  });

  return { buildErrorList, clearErrors, getErrorForPath, mutation, hasError, excludeErrorPaths };
};

export { useUpdatePasswordQuery };
